<template>
    <div class="cancel-modal-mask">
        <div class="cancel-modal-wrapper">
            <div class="cancel-modal-container">
                <div class="cancel-modal-body">
                    <h3>¿Estas seguro que deseas cancelar la publicación de la oferta?</h3>
                    <span>
                        Si cancelas la publicación puedes retomar el proceso de publicación, pero los datos que hayas comlpetado se perderán.
                    </span>
                </div>
                <div class="cancel-modal-footer">
                    <slot name="footer">
                        <button class="btn btn-ghost" @click="hideModal()">No</button>
                        <button class="btn btn-secondary" @click="back()">Sí</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "CancelModal",
  props: ["type"],
  methods: {
    hideModal: function() {
      this.$emit("closeModal");
    },
    back: function() {
      this.$router.push({ path: "/contenido" });
    }
  }
};
</script>

<style lang="sass">
.cancel-modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  display: table
  transition: opacity .3s ease
  text-align:center
.cancel-modal-wrapper
  display: table-cell
  vertical-align: middle
.cancel-modal-container
  max-width: 377px
  border-radius: 8px
  box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
  background-color: #ffffff
  margin: 0 auto
  padding: 16px
  transition: all .3s ease
  @media (max-width: $tablet)
    max-width: calc(100% - 40px)
    margin: 0 8px
.cancel-modal-header
  text-align: center
.cancel-modal-header i
  color: #c90b2f
  font-size: 72px
.cancel-modal-body 
  margin-bottom: 56px
.cancel-modal-body h3
  font-family: Montserrat
  text-align: center
  font-size: 20px
  font-weight: 600
  color: #302f2f
  margin-bottom: 16px
.cancel-modal-body span
  font-family: Muli
  font-size: 16px
  color: #302f2f
.cancel-modal-footer
  text-align: center
  @media (max-width: $tablet)
    margin: 8px auto 0
    width: 80%
    padding: 12px 0
.cancel-modal-footer .btn:first-of-type
  margin-right: 40px
  @media (max-width: $tablet)
    margin-right: 0
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter .cancel-modal-container,
.modal-leave-active .cancel-modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)
</style>


